export const DefaultSettings ={
    notifications_enabled: false,
    settings_enabled: true,
    calendar_enabled: true,
    tutorial_enabled: false,
    billing_enabled: false,
}